import { BaseModel } from "./base.model";

export class ImageModel extends BaseModel {
    id: number;
    baseUrl: string;
    originalUrl: string;
}